<template>
    <div class="login-page">
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
            <div class="container">
                <div class="navbar-wrapper w-100">
                    <a class="navbar-brand w-100" href="https://www.bigscoots.com/" target="_blank">
                        <img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
                    </a>
                </div>
            </div>
        </nav>
        <!-- End Navbar -->
        <div class="wrapper wrapper-full-page ">
            <div class="full-page section-image">
                <div class="content" style="z-index: 1000">
                    <div class="text-center">
                        <router-link :to="{ name: 'login' }" class="loginLink">
                            <i class="nc-icon nc-tap-01"></i> Login To WPO
                        </router-link>
                    </div>
                    <div class="container" style="margin-top: 0">
                        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                            <div class="card"  v-if="!loading">
                                <!-- Show the loader when async operation is going on -->
                                <div class="loader"></div>
                            </div>
                            <form v-else class="form" @submit.prevent="signup">
                                <div class="card card-login">
                                    <div class="card-header ">
                                        <div class="card-header ">
                                            <h3 class="header text-center">Sign Up</h3>
                                        </div>
                                    </div>
                                    <div class="card-body ">
                                        <div class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                  <i class="nc-icon nc-email-85"></i>
                                                </span>
                                            </div>
                                            <input type="email" required class="form-control" placeholder="Email" readonly="readonly" v-model="User.email">
                                        </div>
                                        <div class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                  <i class="nc-icon nc-single-02"></i>
                                                </span>
                                            </div>
                                            <input type="text" required class="form-control" placeholder="First Name" v-model="User.firstName">
                                        </div>
                                        <div class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                  <i class="nc-icon nc-single-02"></i>
                                                </span>
                                            </div>
                                            <input type="text" required class="form-control" placeholder="Last Name" v-model="User.lastName">
                                        </div>
                                        <div class="form-group input-group mb-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                  <i class="nc-icon nc-key-25"></i>
                                                </span>
                                            </div>
                                            <input type="password" required placeholder="Password" class="form-control" v-model="User.password">
                                        </div>
                                        <div class="form-group input-group mb-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                  <i class="nc-icon nc-key-25"></i>
                                                </span>
                                            </div>
                                            <input type="password" required placeholder="Confirm Password" class="form-control" v-model="User.re_password">
                                        </div>
<!--                                        <div class="form-group input-group mb-2">-->
<!--                                            <div class="input-group-prepend">-->
<!--                                                <span class="input-group-text">-->
<!--                                                  <i class="nc-icon nc-bank"></i>-->
<!--                                                </span>-->
<!--                                            </div>-->
<!--                                            <input type="text" required placeholder="Company" class="form-control" v-model="User.company">-->
<!--                                        </div>-->
<!--                                        <div class="form-group input-group mb-2">-->
<!--                                            <div class="input-group-prepend">-->
<!--                                                <span class="input-group-text">-->
<!--                                                  <i class="nc-icon nc-pin-3"></i>-->
<!--                                                </span>-->
<!--                                            </div>-->
<!--                                            <input type="text" required placeholder="City" class="form-control" v-model="User.city">-->
<!--                                        </div>-->
<!--                                        <div class="form-group input-group mb-2">-->
<!--                                            <div class="input-group-prepend">-->
<!--                                                <span class="input-group-text">-->
<!--                                                  <i class="nc-icon nc-pin-3"></i>-->
<!--                                                </span>-->
<!--                                            </div>-->
<!--                                            <input type="text" required placeholder="Country" class="form-control" v-model="User.country">-->
<!--                                        </div>-->
                                        <vue-recaptcha ref="recaptcha" sitekey="6Lca1sUUAAAAAGPmVupZGQn9L03ouRb3m_v5Zftz"  @verify="onVerifyReCaptcha()" @expired="onExpiredReCaptcha()"></vue-recaptcha>
                                        <p class="text-danger text-center mb-0" v-if="feedback"><strong>{{ feedback }}</strong></p>
                                    </div>
                                    <div class="card-footer ">
                                        <button type="submit" class="btn btn-warning btn-round btn-block mb-3" :disabled="disableLoginBtn">{{ loginBtnText }}</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
                <footer class="footer footer-black  footer-white ">
                    <div class="container-fluid">
                        <div class="row">
                            <nav class="footer-nav">
                                <ul>
                                    <li>
                                        <a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
                                    </li>
                                </ul>
                            </nav>
                            <div class="credits ml-auto">
                <span class="copyright">
                  ©
                  {{ currentYear }}, made with
                  <i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>
                </span>
                            </div>
                        </div>
                    </div>
                </footer>
                <div class="full-page-background"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import VueRecaptcha from 'vue-recaptcha';
    import { db, auth } from '@/firebase/init'
    import swal from 'sweetalert2';
    import crypto from 'crypto-js';
    export default {
        name: "Signup",
        components: {
            VueRecaptcha
        },
        data(){
            return {
                captchaVerified: false,
                loading: false,
                User: {
                    email: null,
                    password: null,
                    firstName: null,
                    lastName: null,
                    company: 'N/A',
                    city: 'N/A',
                    country: 'N/A',
                    userType: 'normal',
                    re_password: ''
                },
                rules: [
                    { message:'One lowercase letter required.', regex:/[a-z]+/ },
                    { message:"One uppercase letter required.",  regex:/[A-Z]+/ },
                    { message:"8 characters minimum.", regex:/.{8,}/ },
                    { message:"One number required.", regex:/[0-9]+/ }
                ],
                supervisorUid: '',
                feedback: null,
                loginBtnText: 'Get Started',
                disableLoginBtn: false
            }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear()
            },
            aesSecret() {
                return this.$store.getters["crypto/aesSecret"];
            }
        },
        mounted() {
            this.supervisorUid = crypto.AES.decrypt(this.$route.params.secret.split('Por21Ld').join('/'), this.aesSecret).toString(crypto.enc.Latin1);
            this.User.email = crypto.AES.decrypt(this.$route.params.secret2.split('Por21Ld').join('/'), this.aesSecret).toString(crypto.enc.Latin1);
            document.body.classList.add('login-page');
            $('.form-control').on("focus", function() {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function() {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });
        },
        beforeDestroy() {
            document.body.classList.remove('login-page')
        },
        created () {
            this.loading = true
        },
        methods:{
            onVerifyReCaptcha () {
                console.log('Verified');
                this.captchaVerified = true;
            },
            onExpiredReCaptcha () {
                console.log('Captcha Expire');
                this.captchaVerified = false;
            },
            passwordValidation () {
                let errors = [];
                let errorHtml = '<ul style="text-align: left">';
                for (let condition of this.rules) {
                    if (!condition.regex.test(this.User.password)) {
                        errors.push(condition.message);
                        errorHtml += '<li>'+condition.message+'</li>';
                    }
                }
                errorHtml += '</ul>';
                if (errors.length === 0) {
                    return { valid:true, errors, errorHtml }
                } else {
                    return { valid:false, errors, errorHtml }
                }
            },
            getLoggedUser(uid){
                console.log('Fetching User Info...');
                db.collection('users').doc(uid).get()
                    .then(doc => {
                        // Check if the document exists - then do more checks; Else throw error
                        if(doc.exists) {
                            const user = {
                                firstName: doc.data().firstName,
                                lastName: doc.data().lastName,
                                email: doc.data().email,
                                userType: doc.data().userType,
                                customerID: doc.data().customerID ? doc.data().customerID : null,
                                uid: doc.id,
                                notifications: doc.data().notifications ? doc.data().notifications : false
                            };
                            // Store the received data about the user in the Local Storage
                            localStorage.setItem('userDtls', JSON.stringify(user));

                            // Also dispatch the details to Vuex store
                            this.$store.dispatch('updateUserDetails', user);

                            auth.currentUser.getIdToken().then((idToken)=>{
                                this.$store.dispatch('updateUserDetails', {...user, idToken: idToken})
                                localStorage.setItem('userDtls', JSON.stringify({...user, idToken: idToken}))
                                this.$http.post('/algolia/add-new-record', {
                                  grant_type: 'token',
                                  uid,
                                  firstName : this.User.firstName,
                                  lastName : this.User.lastName,
                                  customerID : '-1',
                                  email : this.User.email,
                                });
                            });

                            this.$store.dispatch("customer/allDetailsUpdate", {...doc.data(), uid: doc.id, docID: doc.id});

                            // Check what kind of a user is this by checking userType of the received data
                            // if userType === admin then redirect to admin page
                            if(user.userType === 'admin' || user.userType === 'manager' || user.userType === 'super-admin') {

                                this.$router.push({ name: 'adminDashboard' });
                                // Enable the login button
                                this.disableLoginBtn = false;

                                // Change login button text to Default
                                this.loginBtnText = 'Get Started';
                            } else {
                                this.$router.push({ name: 'userDashboard' });
                                // Enable the login button
                                this.disableLoginBtn = false;

                                // Change login button text to Default
                                this.loginBtnText = 'Get Started';
                            }
                            this.addLog({
                                name: user.firstName + " " + user.lastName,
                                message: "Logged in",
                                level:  "info"
                            })
                        } else {
                            this.feedback = "No info available about this user in DB. SOL: DelUserManually";
                            // Enable the login button
                            this.disableLoginBtn = false;

                            // Change login button text to Default
                            this.loginBtnText = 'Get Started';
                            this.addLog({
                                name: "Problem with login user: " + this.email,
                                message: this.feedback,
                                level:  "danger"
                            })
                        }
                    })
                    .catch(err => {
                        // Enable the login button
                        this.disableLoginBtn = false;

                        // Change login button text to Default
                        this.loginBtnText = 'Get Started';

                        // Show error
                        this.feedback = err.message;
                        this.addLog({
                            name: "Anonymous",
                            message: err.message,
                            level:  "danger"
                        })
                    })
            },
            signup(){
                if(!this.captchaVerified){
                    swal('Invalid Captcha', 'Please solve captcha first!', 'error');
                    return;
                }
                if(this.User.re_password !== this.User.password){
                    swal('Invalid Password Confirmation', 'Your password does not match! Please try again.', 'error');
                    return;
                }
                const passwordValidation = this.passwordValidation();
                if(!passwordValidation.valid){

                    swal({
                        title: "Invalid Password",
                        html: '<span>Your password must be according to the following guidelines</span><br/>' + passwordValidation.errorHtml,
                        type: "error"
                    });
                    return;
                }
                // Disable the login button
                this.disableLoginBtn = true;

                // Change login button text
                this.loginBtnText = 'Signing you up!';

                // Set error feedback to null
                this.feedback = null;

                // Pass the login details to firebase to login the user
                auth.createUserWithEmailAndPassword(this.User.email, this.User.password)
                    .then(async (credential) => {
                       console.log(credential);
                       console.log(this.supervisorUid);
                       const supervisor = await db.collection('users').doc(this.supervisorUid).get();
                       console.log(supervisor.data());
                       const concernedCollaborators = supervisor.data()['collaborators'];
                       let concernedDomains = [];
                       let allowAll = false;
                       let accessLevels = ['full'];
                       for(let collaborator of concernedCollaborators){
                           if(collaborator.email === this.User.email){
                               concernedDomains = collaborator.domains;
                               allowAll = collaborator.allowAll;
                               accessLevels = collaborator.accessLevels;
                               collaborator.uid = credential.user.uid;
                               collaborator.name = this.User.firstName + ' ' + this.User.lastName;
                               break;
                           }
                       }
                       db.collection('users').doc(credential.user.uid).set({
                           userType: "normal",
                           supervisors: [{
                               supervisorId: supervisor.id,
                               allowedDomains: concernedDomains,
                               allowAll: allowAll,
                               accessLevels,
                               created: new Date().toISOString(),
                               supervisorName: supervisor.data()['firstName'] + ' ' + supervisor.data()['lastName'],
                               supervisorEmail: supervisor.data()['email'],
                               status: 'pending'
                           }],
                           collaborator: true,
                           firstName: this.User.firstName,
                           lastName: this.User.lastName,
                           companyName: this.User.company,
                           city: this.User.city,
                           countryName: this.User.country,
                           email: this.User.email,
                           customerID: '-1',
                           createdAt: Date.now(),
                           updatedAt: Date.now()
                       }).then(async () => {
                           await db.collection('users').doc(this.supervisorUid).update({
                               collaborators: concernedCollaborators
                           });
                           const accountsQuery = await db.collection('hostingAccounts').doc(credential.user.uid).get();
                           if(!accountsQuery.exists){
                               await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: [] , beforePayload: [], action: 'Create User'})
                               await db.collection('hostingAccounts').doc(credential.user.uid).set({
                                   accounts: []
                               });
                           }
                           console.log('User Registered With Id: ' + credential.user.uid);
                           // swal('Success!', 'You are successfully registered! Please continue for login.');
                           await auth.signOut();
                           // this.$router.push({name: "login"});
                           // this.$router.push({ name: 'userDashboard' });
                           // Change login button text
                           this.loginBtnText = 'Logging you in...';
                           auth.signInWithEmailAndPassword(this.User.email, this.User.password).then(() => {
                               this.getLoggedUser(auth.currentUser.uid);
                           }).catch((err) => {
                               this.captchaVerified = false;
                               this.$refs.recaptcha.reset();
                               this.disableLoginBtn = false;
                               this.loginBtnText = 'Get Started';
                               this.feedback = err.message;
                               this.addLog({
                                   name: "Problem with login user: " + this.email,
                                   message: err.message,
                                   level:  "danger"
                               })
                           });
                       });

                    }).catch(err => {
                        this.captchaVerified = false;
                        this.$refs.recaptcha.reset(); // Direct call reset method
                        // Enable the login button
                        this.disableLoginBtn = false;

                        // Change login button text to Default
                        this.loginBtnText = 'Get Started';

                        // Show error
                        this.feedback = err.message;
                        this.addLog({
                            name: "Problem with signing up user: " + this.email,
                            message: err.message,
                            level:  "danger"
                        })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .loginLink{
        color: white;
        font-size: 20px;
        font-weight: bold;
    }
    .loginLink i{
        font-weight: bold;
    }
    .login-page {
    .full-page-background {
        background-image: url('../assets/img/bg/fabio-mangione.jpg');
    }
    .section-image{
    &:after {
         background-color: rgba(90, 124, 253, 0.94)
     }
    }
    .login-bs-logo {
        max-height: 60px;
    }
    }
</style>
